let localizedStrings = {};

/* handle variant changes */
window.addEventListener('DOMContentLoaded', () => {
    setVariantIdParamOnLoad();

    const variantPicker = document.querySelector("variant-picker");
    if (variantPicker) {
        setVariantPickerEventListeners(variantPicker);
    }
    ringgrosseActiveCheck();
    deactivatePurchaseButtonForEheringsetItems();
});

const setVariantPickerEventListeners = (variantPicker) => {
    variantPicker.on('change', handleVariantChange);
}

let tomitLoaded = false;
function handleVariantChange() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdQP = urlParams.get('variant');
    // console.log(variantIdQP);
    if (document.getElementById("variantId")) {
        document.getElementById("variantId").innerText = variantIdQP;
        document.getElementById("variant-id").value = variantIdQP;
    }

    ringgrosseActiveCheck();
    handleBusinessCardChangeForCart(variantIdQP);

    if (tomitLoaded) {
        populateInventoryInfo();
    }

}

function loadTranslations() {
    localizedStrings = window.paTranslations;
}

function setVariantIdParamOnLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("variant") && document.getElementById("variantId") != null) {
        const currentVariantId = document.getElementById("variantId").innerText;
        urlParams.set("variant", currentVariantId);
        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.history.replaceState({}, "", newUrl);
    }
}

/* product availability */
window.addEventListener("load", function () {
    if (document.getElementById("variantId")) {

        document.querySelectorAll('.collapsible').forEach(item => {
            item.addEventListener('click', event => {
                const parent = event.target.parentElement;
                const content = parent.querySelector('.collapsible-content');
                content.style.display = content.style.display === 'block' ? 'none' : 'block';
            });
        });

        document.querySelector('#goToStep2').addEventListener('click', event => {
            document.getElementById("formStep1").style.display = "none";
            document.getElementById("formStep2").style.display = "block";
            document.getElementById("storeAvailabilityTopAnchor").scrollIntoView();
        });

        document.querySelector('#goToStep1').addEventListener('click', event => {
            document.getElementById("formStep1").style.display = "block";
            document.getElementById("formStep2").style.display = "none";
            document.getElementById("storeAvailabilityTopAnchor").scrollIntoView();
        });

    }

    loadTranslations();

});
document.addEventListener('tomitLoaded', tomitHasLoaded);

function tomitHasLoaded() {
    tomitLoaded = true;
    populateInventoryInfo();
    const storeAvailabilityOuterWrap = document.getElementById("storeAvailabilityOuterWrap");
    if (storeAvailabilityOuterWrap == null) return;
    storeAvailabilityOuterWrap.classList.remove("loading");
}

function populateInventoryInfo() {
    const storeAvailabilityWrap = document.getElementById("storeAvailabilityWrap");
    const notAvailableNoticeWrap = document.getElementById("storeAvailabilityNotAvailableWrap");

    if(storeAvailabilityWrap == null) return;

    storeAvailabilityWrap.classList.add("loading");
    storeAvailabilityWrap.classList.remove("hidden");
    notAvailableNoticeWrap.classList.add("hidden");


    setTimeout(() => {
        if (!document.getElementById("variantId")) return;

        const variantId = document.getElementById("variantId").innerText;
        let cnt = 0;
        
        if (jtcProductInventoryInfo &&
            jtcProductInventoryInfo["data"] &&
            jtcProductInventoryInfo["data"]["variants"] &&
            jtcProductInventoryInfo["data"]["variants"][variantId] &&
            jtcProductInventoryInfo["data"]["variants"][variantId]["locations"]) {
            const locations = jtcProductInventoryInfo["data"]["variants"][variantId]["locations"];
            //console.log(locations);

            let inventoryInfoWrap = document.createElement("div");
            inventoryInfoWrap.classList.add("stores-wrap");
            inventoryInfoWrap.id = "invLocationInformation";

            let foundFirstAvailable = false;
            let seenLocations = [];
            //let emptyStockContinue = false;


            // account for possible location address duplicates / stock levels
            let stockByLocation = {};
            for (let i = 0; i < locations.length; ++i) {
                const location = locations[i];
                let locationAddress = location.address1 + ", " + location.city;
                if (!stockByLocation[locationAddress]) {
                    stockByLocation[locationAddress] = location.stock;
                } else {
                    stockByLocation[locationAddress] += location.stock;
                }
            }

            for (let i = 0; i < locations.length; ++i) {
                const location = locations[i];
                if (location.enabled == false) continue;

                let locationAddress = location.address1 + ", " + location.city;
                if (seenLocations.includes(locationAddress)) continue;
                seenLocations.push(locationAddress);

                let stockAvailable = false;
                if (stockByLocation[locationAddress] && stockByLocation[locationAddress] > 0) {
                    stockAvailable = true;
                    let button2 = document.getElementById("goToStep2");
                    button2.innerText = localizedStrings.reserve;
                }


                const inventoryLocation = document.createElement("input");
                inventoryLocation.setAttribute("type", "radio");
                inventoryLocation.setAttribute("name", "filiale");
                inventoryLocation.id = "loc-" + cnt;
                inventoryLocation.setAttribute("value", locationAddress);

                if (foundFirstAvailable == false && stockByLocation[locationAddress] && stockByLocation[locationAddress] > 0) {
                    inventoryLocation.setAttribute("checked", "checked");
                    //document.querySelector("#formStep1 .sa-btn-wrap").style.display = "flex";
                    foundFirstAvailable = true;
                }

                let inventoryInfoItem = document.createElement("div");
                inventoryInfoItem.classList.add("inventory-info-item");

                if (!stockAvailable) {
                    inventoryInfoItem.classList.add("on-request");
                    locationAddress += '<span>' + localizedStrings.request + '</span>';
                } else {
                    inventoryInfoItem.classList.add("stock-available");
                    inventoryLocation.classList.add("in-stock");
                    locationAddress += '<span>' + localizedStrings.available + '</span>';
                }

                const inventoryLocationLabel = document.createElement("label");
                inventoryLocationLabel.setAttribute("for", "loc-" + cnt);
                inventoryLocationLabel.innerHTML = locationAddress;

                inventoryInfoItem.appendChild(inventoryLocation);
                inventoryInfoItem.appendChild(inventoryLocationLabel);



                /* not in use if using continueSellingIfOutOfStock button
                if(document.querySelector('#emptyStockContinue--' + variantId) != null) {
                    emptyStockContinue = true;
                }
                if(stockAvailable) {
                  inventoryInfoWrap.appendChild(inventoryInfoItem);
                } else if (!stockAvailable && emptyStockContinue === true) {
                  inventoryInfoWrap.appendChild(inventoryInfoItem);
                }
                */
                inventoryInfoWrap.appendChild(inventoryInfoItem);

                cnt++;

            };

            if (foundFirstAvailable == false && !storeAvailabilityWrap.classList.contains("eigenbau-product")) {
                storeAvailabilityWrap.classList.add("hidden");
                notAvailableNoticeWrap.classList.remove("hidden");
                return;
            }

            /*
            if (foundFirstAvailable == false) {
                // document.querySelector("#formStep1 .sa-btn-wrap").style.display = "none";
                }
            */

            let inventoryLocationInformation = document.getElementById("inventoryLocationInformationFeiSP");
            if (!inventoryLocationInformation) {
                inventoryLocationInformation = document.getElementById("invLocationInformation");
            }
            inventoryLocationInformation.replaceWith(inventoryInfoWrap);
            storeAvailabilityWrap.classList.remove("loading");

            let originalILI = document.getElementById("inventoryLocationInformation");
            if (originalILI != null) {
                originalILI.innerHTML = "";
            }

            if (foundFirstAvailable == false) {
                // mark first radio button
                document.querySelector(".inventory-info-item input").setAttribute("checked", "checked");
                /*
                if(emptyStockContinue == false) {
                  document.getElementById("storeAvailabilityWrap").style.display = "none";
                }
                */
            }
            setChangeStoreRadioNameListener();

        }

        if(cnt == 0) {
            if(storeAvailabilityWrap.closest('.store-availability-wrap') != null) {
                storeAvailabilityWrap.closest('.store-availability-wrap').classList.add("hidden");
            }
        }

    }, 1500);
};

function setChangeStoreRadioNameListener() {

    let button2 = document.getElementById("goToStep2");
    let items = document.querySelectorAll(".inventory-info-item");
    items.forEach(item => {
        item.addEventListener("click", function (e) {
            if (e.target.classList.contains("in-stock")) {
                button2.innerText = localizedStrings.reserve;
            } else {
                button2.innerText = localizedStrings.request;
            }
        })
    })
}


/* toast notification */
const showToast = (
    message = "Message",
    toastType = "notice",
    duration = 5000) => {

    let box = document.createElement("div");
    box.classList.add(
        "toast-srpl", `toast-${toastType}`);
    box.innerHTML = ` <div class="toast-content-wrapper"> 
                      <div class="toast-message">${message}</div> 
                      <div class="toast-close"><span class="close-button-with-scale-hover"></span></div>
                      </div>`;
    duration = duration || 5000;

    let toastAlready =
        document.body.querySelector(".toast-srpl");
    if (toastAlready) {
        toastAlready.remove();
    }

    document.body.appendChild(box);
    setTimeout(() => {
        box.classList.add("closed");
        //box.remove(); 
    }, duration);
    box.querySelector(".toast-close").addEventListener("click", () => {
        box.classList.add("closed");
    });
};

function showToastGiftBoxInCart() {
    setTimeout(() => {
        showToast("Diese Geschenkbox wurde Ihrem zuletzt geöffneten Produkt hinzugefügt", "notice", 5000);
    }, 1500)
}


function ringgrosseActiveCheck() {
    if (document.getElementById("ringgrosseActive557")) {
        ringrosseCheckSelectedValue();
        const ringSelector = document.querySelector('#ringgrosse');
        ringSelector.addEventListener("change", ringrosseCheckSelectedValue);
    }
}

function ringrosseCheckSelectedValue() {
    const ringSelector = document.querySelector('#ringgrosse');
    const formSubmitButton = document.querySelector(".product-form__btn-wrapper button");
    if (ringSelector && ringSelector.value) {
        formSubmitButton.classList.remove("submit-button-disabled"); // additional selector, it should not clash with disabled attribute
    } else {
        formSubmitButton.classList.add("submit-button-disabled");
    }

    if (formSubmitButton.classList.contains("loading")) {
        setTimeout(ringrosseCheckSelectedValue, 500);
    }

}

function handleBusinessCardChangeForCart(variantId) {
    let metafieldcontainer = document.getElementById("hidden-variant-metafields-container");
    let variantsBcpreis =
        JSON.parse(metafieldcontainer.innerHTML);
    let index = -1;
    let val = variantId;
    variantsBcpreis.find(function (item, i) {
        if (item.variant_id == val) {
            index = i;
            return i;
        }
    })
    let bcpreis = variantsBcpreis[index].metafield_value;
    let priceCurrent = document.querySelector(".product-price__current-price .product-price-ref").innerText;
    let bcdiscount = (priceCurrent - bcpreis) / 100;

    document.getElementById("bcpreis").value = bcdiscount;
}

function deactivatePurchaseButtonForEheringsetItems() {
    const productTitle = document.querySelector(".product__info h1");
    if (productTitle && (productTitle.innerText.toLowerCase().includes("eheringset") || productTitle.innerText.toLowerCase().includes("partnerset"))) {
        const purchaseButton = document.querySelector(".product-form__btn-wrapper button")
        if (purchaseButton) {
            purchaseButton.classList.add("submit-button-disabled");
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const paginationLink = customElements.get('pagination-link')?.prototype;
    if (!paginationLink) {
        return;
    }
    const originalGetFromUrl = paginationLink.getFromUrl;
    paginationLink.getFromUrl = function (url) {
        originalGetFromUrl.call(this, url);
        //add url to history
        window.history.pushState({}, '', url);
    };
});

//create custom component range-slider

class RangeSlider extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                .range-slider {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                }
                .range-slider__label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #333;
                }
                .range-slider__input {
                    width: 100%;
                    height: 1px;
                    margin-top: 8px;
                    margin-bottom: 26px;
                    background: transparent;
                    -webkit-appearance: none;
                }
                
                .range-slider__input::-webkit-slider-runnable-track {
                    height: 1px;
                    background: #d4d4d8;
                }
                
                .range-slider__input::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    height: 16px;
                    width: 16px;
                    background: #2D281A; /* Change this to your custom color */
                    border-radius: 50%;
                    cursor: pointer;
                    margin-top: -7.5px; /* This should be negative half of the thumb height to center it on the track */
                }
                
                .range-slider__input::-moz-range-track {
                    height: 1px;
                    background: #d4d4d8;
                }
                
                .range-slider__input::-moz-range-thumb {
                    height: 16px;
                    width: 16px;
                    background: #2D281A; /* Change this to your custom color */
                    border-radius: 50%;
                    cursor: pointer;
                }
                
                .range-slider__input::-ms-track {
                    height: 1px;
                    background: transparent;
                    border-color: transparent;
                    color: transparent;
                }
                
                .range-slider__input::-ms-thumb {
                    height: 16px;
                    width: 16px;
                    background: #2D281A; /* Change this to your custom color */
                    border-radius: 50%;
                    cursor: pointer;
                }
                .range-slider__ticks {
                    display: flex;
                    width: 100%;
                    justify-content: space-between;                                      
                }
                .range-slider__tick {                                       
                    max-width: 2rem;
                    cursor: pointer;
                }
                .range-slider__tick-label {
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                    font-family: Poppins, sans-serif;
                }
            </style>
            <div class="range-slider">
                <input class="range-slider__input" type="range" id="range-slider" min="${this.getAttribute('min')}" max="${this.getAttribute('max')}" value="${this.getAttribute('value')}" step="${this.getAttribute('step') || 1}">                
                <div class="range-slider__ticks"></div>
            </div>
        `;
    }

    connectedCallback() {
        const min = parseInt(this.getAttribute('min'), 10);
        const max = parseInt(this.getAttribute('max'), 10);
        const step = parseInt(this.getAttribute('step'), 10) || 1;
        const ticksContainer = this.shadowRoot.querySelector('.range-slider__ticks');

        for (let i = min; i <= max; i += step) {
            const tick = document.createElement('div');
            tick.classList.add('range-slider__tick');

            const label = document.createElement('span');
            label.classList.add('range-slider__tick-label');
            label.textContent = i > 0 ? `+${i}` : i;

            tick.appendChild(label);
            ticksContainer.appendChild(tick);

            tick.addEventListener('click', () => {
                this.shadowRoot.querySelector('.range-slider__input').value = i;
                //dispatch event to outer dom
                this.dispatchEvent(new CustomEvent('change', {
                    detail: {
                        value: i
                    }
                }));
            });
        }

        this.shadowRoot.querySelector('.range-slider__input').addEventListener('input', () => {
            //dispatch event to outer dom
            this.dispatchEvent(new CustomEvent('change', {
                detail: {
                    value: this.shadowRoot.querySelector('.range-slider__input').value
                }
            }));
        });
    }
}
//register component
customElements.define('range-slider', RangeSlider);



// handle remove cart item event, for related ring-size-adjust-products
document.addEventListener('cart:item-remove', function(event) {
    let removedVariantId = event.detail;
      removeSizeAdjustByVariant(removedVariantId);
  });

  async function removeSizeAdjustByVariant(removedVariantId) {
  // first catch rel_id of removed item from reference cart object (stored in fcart_ref object), then find related object in current cart
  try {
    const cart_ref = window.fcart_ref; 
    if (!cart_ref) {
      return;
    }

    const variantItems = cart_ref.items.filter(i => Number(i.variant_id) === Number(removedVariantId));
    if (variantItems.length === 0) {
      return;
    }

    for (const item of variantItems) {

    if(item.properties) { // we have related size adjust product
 
      if (!item.properties._rel_id_as && !item.properties._rel_id_lpo) {
        return;
      }

      // find related object in current cart, relatedItemIndex should be line index in cart..
      const currentCart = await fetch("/cart.js").then(res => res.json());

      const relId = item.properties._rel_id_as ? item.properties._rel_id_as : item.properties._rel_id_lpo;

      let relatedItemIndex = -1;
      if(item.properties._rel_id_as != null) { // size adjust product
        relatedItemIndex = currentCart?.items.findIndex(i => i.properties && i.properties?._rel_id_as?.trim() === relId.trim() &&  Number(i.variant_id) !=  Number(removedVariantId));
      } else if(item.properties._rel_id_lpo != null) { // live preview option product 
        relatedItemIndex = currentCart?.items.findIndex(i => i.properties && i.properties?._rel_id_lpo?.trim() === relId.trim() &&  Number(i.variant_id) !=  Number(removedVariantId));
      }

      if (relatedItemIndex !== -1) {
      const relatedItem = currentCart.items[relatedItemIndex];

      // copy properties and remove size adjust properties
      const newProperties = {...relatedItem.properties};
      let mainItemRemoval = false;

      if(newProperties._rel_id_as) {
        if(newProperties._sizeadjust) { // in this case size-adjust-product was deleted, so we remove properties on the main product
            delete newProperties._sizeadjust;
            delete newProperties._sizeadjust_price;
            delete newProperties._rel_id_as;
        } else {
            mainItemRemoval = true; // else main item was removed, so we remove related size-adjust-product
        }
      } 
      if(newProperties._rel_id_lpo) {
        if(newProperties["gravur hinzufügen"]) { // in this case live-preview-options product was deleted, so we remove properties on the main product
            delete newProperties["gravur hinzufügen"];
            delete newProperties["text-vorderseite"];
            delete newProperties["text-rückseite"];
            delete newProperties["Schriftart"];
            delete newProperties._rel_id_lpo;
        } else {
            mainItemRemoval = true; // else main item was removed, so we remove related live-preview-options product
        }
      }
      console.log("New properties after:", newProperties);


      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            line: relatedItemIndex + 1,  // 1-based index
            quantity: !mainItemRemoval ? relatedItem.quantity : 0,
            properties: newProperties
        })
        });

        document.querySelector('cart-drawer') && document.querySelectorAll('cart-drawer').forEach(drawer => drawer.dispatchEvent(new CustomEvent('cart:shouldrefresh'))); 
        document.querySelector('cart-page') && document.querySelectorAll('cart-page').forEach(cartPage => cartPage.dispatchEvent(new CustomEvent('cart:shouldrefresh')));


        // update reference cart object, remove from uniquesArr & items array
        const removedVariantKey = removedVariantId + "_" + relId;
        const removedVariantRelatedItemKey = relatedItem.variant_id + "_" + relId;
        const updatedUniquesArr = cart_ref.uniquesArr.filter(key => key !== removedVariantKey && key !== removedVariantRelatedItemKey);
        cart_ref.uniquesArr = updatedUniquesArr;

        cart_ref.items = cart_ref.items.filter(i => i.properties && (i.properties._rel_id_as !== relId && i.properties._rel_id_lpo !== relId));

        window.fcart_ref = cart_ref; 
        }
        
    }
  }
    
  } catch (err) {
    console.error("Error removing size adjust:", err);
  }
}